export default __webpack_public_path__ + "static/media/ceov3.f0a9c3dc.png";